import React, { useState } from 'react';
import { createDataTable } from '@/components/DataTable';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import { BygrProfile } from '@/types';
import { CustomLink, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { getProfiles, getProfilesExportUrl } from '@/services/profiles';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import AddProfileModal from './AddProfileModal';
import { Button } from '@ygtechnologies/rubus-ui';

const DataTable = createDataTable<BygrProfile>();

const ProfileTable: React.FC<{}> = () => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('name'));
    const [data, , reload, isLoading] = useAsyncStateWithIsLoading(() => getProfiles(tableState), [tableState], null);
    const [addProfileModalIsOpen, setAddProfileModalIsOpen] = useState(false);

    if (!data) {
        return <LoadingIndicator />;
    }

    return (
        <div>
            <h2>Seller profiles</h2>
            <DataTable
                exportUrl={getProfilesExportUrl(tableState)}
                hasSearchField
                isLoading={isLoading}
                data={data.items}
                onStateChange={setTableState}
                state={tableState}
                totalItemCount={data.totalCount}
                toolbarActions={
                    <Button size="sm" variant="primary" onClick={() => setAddProfileModalIsOpen(true)} icon={faPlus}>
                        Create new profile
                    </Button>
                }
                className="table style-3">
                <DataTable.Column header="ID" field="id" sortable />
                <DataTable.Column
                    header="Name"
                    field="name"
                    sortable
                    renderer={({ row, value }) => <CustomLink to={`/profiles/${row.id}`}>{value}</CustomLink>}
                />
                <DataTable.Column
                    header="Is Paying"
                    field="isPaying"
                    sortable
                    renderer={({ value }) => (value ? 'Yes' : 'No')}
                />

                <DataTable.Column
                    header="Number Of Members"
                    field="numberOfMembers"
                    sortable
                    renderer={({ value }) => value}
                />
            </DataTable>

            <AddProfileModal onSave={reload} isOpen={addProfileModalIsOpen} toggle={() => setAddProfileModalIsOpen(false)} />
        </div>
    );
};

export default ProfileTable;
